import { createRouter, createWebHistory } from "vue-router";
import Login from "../views/Login.vue";
import Home from "../views/Home.vue";

const routes = [
  // {
  //   path: "/about",
  //   name: "About",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/About.vue"),
  // },
  {
    path: "/",
    component: Home,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      title: '登录'
    }
  },
  {
    path: "/home",
    name: "Home",
    component: Home,
    children: [
      {
        path: "/index",
        name: "index",
        meta: {
          title: "首页",
        },
        component: () => import(/* webpackChunkName: "norm-manage" */ "../views/Index.vue")
      },
      {
        path: "/norm-manage",
        name: "norm-manage",
        meta: {
          title: "指标管理页面",
        },
        component: () => import(/* webpackChunkName: "norm-manage" */ "../views/NormManage.vue")
      },
      {
        path: "/task-accept",
        name: "task-accept",
        meta: {
          title: '任务接受页面'
        },
        component: () => import(/* webpackChunkName: "task-accept" */ "../views/TaskAccept.vue")
      },
      {
        path: "/personal-report",
        name: "personal-report",
        meta: {
          title: '个人工作小结报告'
        },
        component: () => import(/* webpackChunkName: "personal-report" */ "../views/PersonalReport.vue")
      },
      {
        path: "/eva-model",
        name: "eva-model",
        meta: {
          title: '评估模型页面'
        },
        component: () => import(/* webpackChunkName: "eva-model" */ "../views/EvaModel.vue")
      },
      {
        path: "/eva-events",
        name: "eva-events",
        meta: {
          title: '待评分项目'
        },
        component: () => import(/* webpackChunkName: "eva-items" */ "../views/EvaEvents.vue")
      },
      {
        path: "/department-task-make",
        name: "department-task-make",
        meta: {
          title: '科室工作任务制定'
        },
        component: () => import(/* webpackChunkName: "department-task-make" */ "../views/DepTaskMake.vue")
      },
      {
        path: "/personal-task-make",
        name: "personal-task-make",
        meta: {
          title: '科室工作任务制定'
        },
        component: () => import(/* webpackChunkName: "personal-task-make" */ "../views/PersonalTaskMake.vue")
      },
      {
        path: "/department-task-distribute",
        name: "department-task-distribute",
        meta: {
          title: '科室工作任务下发'
        },
        component: () => import(/* webpackChunkName: "department-task-distribute" */ "../views/DepTaskDistribute.vue")
      },
      {
        path: "/task-plan-review",
        name: "task-plan-review",
        meta: {
          title: '工作任务审批'
        },
        component: () => import(/* webpackChunkName: "task-plan-review" */ "../views/TaskPlanReview.vue")
      },
      {
        path: "/personal-report-review",
        name: "personal-report-review",
        meta: {
          title: '个人工作小结审批'
        },
        component: () => import(/* webpackChunkName: "personal-report-review" */ "../views/PersonalReportReview.vue")
      },
      {
        path: "/employee-manage",
        name: "employee-manage",
        meta: {
          title: '人员信息管理'
        },
        component: () => import(/* webpackChunkName: "employee-manage" */ "../views/EmployeeManage.vue")
      },
      {
        path: "/employee-manage2",
        name: "employee-manage2",
        meta: {
          title: '人员调动'
        },
        component: () => import(/* webpackChunkName: "employee-manage2" */ "../views/EmployeeManage2.vue")
      },
      {
        path: "/personal-eva",
        name: "personal-eva",
        meta: {
          title: '个性指标评价列表'
        },
        component: () => import(/* webpackChunkName: "personal-eva" */ "../views/PersonalEva.vue")
      },
      {
        path: "/department-manage",
        name: "department-manage",
        meta: {
          title: '部门管理'
        },
        component: () => import(/* webpackChunkName: "department-manage" */ "../views/DepartmentManage.vue")
      },
      // {
      //   path: "/employee-manage",
      //   name: "employee-manage",
      //   meta: {
      //     title: '人员管理'
      //   },
      //   component: () => import(/* webpackChunkName: "employee-manage" */ "../views/EmployeeManage.vue")
      // },
      {
        path: "/eva-result-display",
        name: "eva-result-display",
        meta: {
          title: '考核成绩公示'
        },
        component: () => import(/* webpackChunkName: "eva-result-display" */ "../views/EvaResultDisplay.vue")
      },
      {
        path: "/eva-result-display-cancel",
        name: "eva-result-display-cancel",
        meta: {
          title: '考核成绩公示否决示例'
        },
        component: () => import(/* webpackChunkName: "eva-result-display" */ "../views/EvaResultDisplayCancel.vue")
      },
      {
        path: "/as-item",
        name: "as-item",
        meta: {
          title: '加减分情况管理'
        },
        component: () => import(/* webpackChunkName: "as-item" */ "../views/ASItem.vue")
      },
      {
        path: "/rate-manage",
        name: "rate-manage",
        meta: {
          title: '评等配置'
        },
        component: () => import(/* webpackChunkName: "rate-manage" */ "../views/RateManage.vue")
      },
      {
        path: "/key-task-manage",
        name: "key-task-manage",
        meta: {
          title: '评等配置'
        },
        component: () => import(/* webpackChunkName: "key-task-manage" */ "../views/KeyTaskManage.vue")
      },
      {
        path: "/attendance-manage",
        name: "attendance-manage",
        meta: {
          title: '评等配置'
        },
        component: () => import(/* webpackChunkName: "attendance-manage" */ "../views/AttendanceManage.vue")
      },
      {
        path: "/bureau-manage",
        name: "bureau-manage",
        meta: {
          title: '评等配置'
        },
        component: () => import(/* webpackChunkName: "bureau-manage" */ "../views/BureauManage.vue")
      },
      {
        path: "/file-browse",
        name: "file-browse",
        meta: {
          title: '评等配置'
        },
        component: () => import(/* webpackChunkName: "file-browse" */ "../views/FileBrowse.vue")
      },
    ]
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
